import { useCallback, useState } from "react";
import { Menu } from "lucide-react";
import { NAV } from "./content";
import { MobileNav } from "./MobileNav";

export const Logo = ({ className = "" }) => (
  <img
    src="/assets/dellsjo-logo.png"
    alt="Dellsjö Städ- & trädgårdsservice"
    className={className}
    width="720"
    height="229"
  />
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  return (
  <header
    className="sticky top-0 z-40 border-b border-[var(--line)] bg-white/90 backdrop-blur-md"
    data-testid="site-header"
  >
    <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 sm:px-6 lg:h-[72px]">
      <a href="#top" aria-label="Till toppen" data-testid="header-logo-link" className="shrink-0">
        <Logo className="h-10 w-auto lg:h-12" />
      </a>
      <nav className="hidden items-center gap-1 lg:flex" aria-label="Huvudmeny">
        {NAV.map((n) => (
          <a
            key={n.id}
            href={`#${n.id}`}
            data-testid={`nav-link-${n.id}`}
            className="rounded-full px-3 py-2 text-[0.95rem] font-medium text-[var(--ink-soft)] transition-colors hover:bg-[var(--sand)] hover:text-[var(--ink)]"
          >
            {n.label}
          </a>
        ))}
      </nav>
      <div className="flex items-center gap-2">
        <a href="#offert" className="btn btn-red !min-h-[44px] !px-4 text-sm sm:text-base" data-testid="header-quote-button">
          Begär offert
        </a>
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="Meny"
          aria-expanded={open}
          aria-controls="mobile-nav"
          className="grid h-11 w-11 place-items-center rounded-full border border-[var(--line)] hover:bg-[var(--sand)] lg:hidden"
          data-testid="mobile-nav-toggle"
        >
          <Menu size={22} aria-hidden />
        </button>
      </div>
    </div>
    <MobileNav open={open} onClose={close} Logo={Logo} />
  </header>
  );
};
